module.exports = __webpack_public_path__ + "a21d7db2d5cd7acc08d11e4fbe335547.svg";